import { Injectable } from '@angular/core';
import { Http, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { Address } from '../interface/address';
import { SponsorInformation, SponsorSearchRequest, SponsorSearchResponse, ZipCodePattern } from '../interface/enrollment';
import { SponsorDetails } from '../interface/enrollment/sponsor-details.interface';
import { OrderType } from '../common/enumerations';

@Injectable()
export class SponsorService {
  constructor(private _http: Http) { }


  /**
 * @description get store by countrycode
 * @param {string} countryCode
 * @returns {Observable<any[]>}
 * @memberof CommonService
 */
getStoreByCountryCode(countryCode: string): Observable<StoreConfig> {
  const _url =
    ApiUrlConstants.configurationApiUrl + 'store-countries/' + countryCode.toUpperCase();
  return this._http
    .get(_url)
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
}

   /**
   * @description to get all the Zip Code Patterns
   * @returns {Observable<any>}
   * @memberof CommonService
   */
  getZipCodePatterns(): Observable<ZipCodePattern[]> {
    return this._http
      .get(environment.uiTemplateBaseUrl + '/test/zipcode-configuration.json')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getGovermentIdentificationPatterns(): Observable<any[]> {
    return this._http
      .get(environment.uiTemplateBaseUrl + '/test/goverment-identification-patterns.json')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

    /**
   * Sponsor Search
   * @param  {any} sponsorSearchRequest
   * @param  {number} limit?
   * @returns Observable
   */
  searchSponsors(sponsorSearchRequest: SponsorSearchRequest, orderType?: OrderType,limit?: number)
    : Observable<SponsorSearchResponse> {
      const flowtype = OrderType[orderType];
    const _searchSponsorUrl = ApiUrlConstants.enrollmentApigwUrl +
      `sponsor-search?flowtype=${flowtype}&app=csp`;
    return this._http
      .post(_searchSponsorUrl, sponsorSearchRequest)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  sponsorOptions(countryCode: string): Observable<SponsorInformation> {
    const _searchSponsorUrl = ApiUrlConstants.accountApiUrl +
      'countries/' + countryCode + '/sponsor-search-options';
      // '/countries/usa/sponsor-search-options';
    return this._http
      .get(_searchSponsorUrl)
      // .get('/assets/test/sponsor-option.json')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description
   * @param {string} sponsorId
   * @param {string} sponsorCountry
   * @returns {Observable<any>}
   * @memberof SponsorService
   */
  sponsorEligibilityCheck(sponsorId: string, sponsorCountry: string,searchOption ?:number): Observable<any> {
    let _searchSponsorUrl = ApiUrlConstants.accountApiUrl +
      'sponsor-eligibility-check/' + sponsorId + '/' + sponsorCountry;
      if(searchOption && searchOption > 0){
        _searchSponsorUrl += "?option=" +searchOption
      }
    return this._http
      .get(_searchSponsorUrl)
      // .get('/assets/test/sponsor-option.json')
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getSponsorEligibility(selectedSponsor: SponsorInformation): Observable<any> {
    const _sponsorEligibityUrl =
      ApiUrlConstants.accountApiUrl +
      'enrollment/member/sponsor-eligibility?sponsorId=' +
      selectedSponsor.sponsorId +
      '&countryId=' +
      selectedSponsor.sponsorCountryId +
      '&sponsorCountry=' +
      selectedSponsor.sponsorCountryCode;
    return this._http
      .get(_sponsorEligibityUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
   * @description To update the PC sponsor eligibility
   * @memberof SponsorService
   */
  updatePCSponsorElgibility(memberId:number, requestArray:any){
    const _updateSponsorEligibityUrl =
      ApiUrlConstants.accountApiUrl + 'member/' + memberId + '/update-PCSponsorEligibility';
      return this._http
      .put(_updateSponsorEligibityUrl,requestArray)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  /**
   * @description
   * @param {string} sponsorId
   * @returns {Observable<SponsorSearchResponse>}
   * @memberof SponsorService
   */
  searchSponsorById(sponsorId: string): Observable<SponsorSearchResponse> {
    const _searchSponsorUrl =
      ApiUrlConstants.accountApiUrl +
      'enrollment/member/sponsor-search?searchType=BY-SPONSOR&searchBy=sponsorId&sponsorId=' +
      sponsorId;
    return this._http
      .get(decodeURIComponent(encodeURIComponent(_searchSponsorUrl)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * @description this method will  get sponsor by uuid
   * @returns {Observable<SponsorInformation>}
   * @memberof SponsorService
   */
  getSearchSponsorsByUUID(sponsorSearchResponse: SponsorSearchResponse): Observable<SponsorSearchResponse> {
    const _searchSponsorUrl = sponsorSearchResponse.location;
    return this._http
      .get(decodeURIComponent(encodeURIComponent(_searchSponsorUrl)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /** 
     * get Sponsor Details By memberID
     * @date 2021-02-23
     * @memberof SponsorService
     */
  getSponsorDetailsByMemberID(memberId: number) : Observable<SponsorDetails[]> {
    const url = ApiUrlConstants.accountApiUrl + 'member/' + memberId +'/sponsor';
    return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
  /**
   * @description this method will map addess
   * of sponsor
   * @param {*} sponsor
   * @returns {Address}
   * @memberof SponsorSelectionComponentNew
   */
  mapAddressModel(sponsor: SponsorInformation): Address {
    // creating a address object to be added to sponsor info
    const address = {
      id: null,
      memberId: null,
      addressLine1: sponsor.sponsorAddressLine1,
      addressLine2: null,
      addressLine3: null,
      addressLine4: null,
      city: sponsor.sponsorCity,
      stateId: sponsor.sponsorStateId,
      countryId: sponsor.sponsorCountryId,
      postalCode: sponsor.sponsorPostalCode,
      addressVerificationStatus: false,
      addressType: null,
      state: sponsor.sponsorStateCode,
      stateCode: sponsor.sponsorStateCode,
      countryCode: sponsor.sponsorCountryCode,
      country: sponsor.sponsorCountryCode,
      latitude: null,
      longitude: null,
      defaultAddress: null,
      county: null,
      name: null,
      company: null,
      errorCodes: null,
      formattedAddress: null,
      organization: null,
      countryFullName: null,
      phone: null,
      countryCodeTwo: null,
      residential: false,
      validAddress: false
    };
    return address;
  }

  /**
    * to get Communication Preferences for member
    * @param
    * @returns Observable
    */
   getMemberCommunicationPreferences(id: number): Observable<any> {
    const options = new RequestOptions({
      method: 0
    });
    const m = this._http
      .get(ApiUrlConstants.accountApiUrl + 'members/' + id + '/preferences', options)
      .map(response => response.json())
      .catch(this.handleErrorObservable);
    return m;
  }


    /**
 * @description To handle the obervable error response
 * @param  {Response|any} error
 */
private handleErrorObservable(error: Response | any) {
    return Observable.throw(error.message || error);
  }

  /**
   * This method used to get fbo referal id
   * getBusinessEntityByHomeCountryCode()
   */
  getBusinessEntityByHomeCountryCode(homeCountryCode: string): Observable<SponsorDetails[]> {
    const url = ApiUrlConstants.configurationApiUrl + '/business-entities/' + homeCountryCode + '/details';
    return this._http.get(url)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/sponsor.service.ts